export const blockIconsTravelNightlifeNew = (
	<span className='material-symbols-outlined'>nightlife</span>
);
